import Vue from 'vue'

Vue.filter('title', function (value, replacer = '_') {
  if (!value) return ''
  value = value.toString()

  const arr = value.split(replacer)
  const capitalized_array = []
  arr.forEach((word) => {
    // const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    const capitalized = word.charAt(0) + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(' ')
})

/**
 * Formato de números con separador de miles '.' y decimales ',' (XXX.XXX.XXX,00 o sin decimales)
 */
Vue.filter('numberFormat', function (value, decimals = 0) {
  if (value === null || value === undefined || value === '' || isNaN(Number(value))) {
    return '0'
  }
  const num = Number(value)
  return num.toLocaleString('de-DE', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })
})

/**
 * Formato de moneda para Balboas de Panamá: B/. XXX.XXX.XXX,00
 * Si es negativo: B/. -XXX.XXX.XXX,00
 */
Vue.filter('currency', function (value, decimals = 2) {
  if (value === null || value === undefined || value === '' || isNaN(Number(value))) {
    return 'B/. 0,00'
  }
  const num = Number(value)
  const isNegative = num < 0
  const formatted = Math.abs(num).toLocaleString('de-DE', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })
  return isNegative ? `B/. -${formatted}` : `B/. ${formatted}`
})

Vue.prototype.$formatNumber = function (value, decimals = 0) {
  if (value === null || value === undefined || value === '' || isNaN(Number(value))) {
    return '0'
  }
  const num = Number(value)
  return num.toLocaleString('de-DE', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })
}

Vue.prototype.$formatCurrency = function (value, decimals = 2) {
  if (value === null || value === undefined || value === '' || isNaN(Number(value))) {
    return 'B/. 0,00'
  }
  const num = Number(value)
  const isNegative = num < 0
  const formatted = Math.abs(num).toLocaleString('de-DE', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })
  return isNegative ? `B/. -${formatted}` : `B/. ${formatted}`
}
